export default "__VITE_ASSET__B1oD4cTk__"